import { Component, Method, Prop, h } from '@stencil/core';

@Component({
  tag: 'ico-iframe-modal',
  styleUrl: 'ico-iframe-modal.css',
  shadow: true,
})
export class IcoIframeModal {
  @Prop() url: string;
  @Prop() shouldCloseOnClickingBackdrop: boolean = true;
  dialog: HTMLDialogElement;

  @Method()
  async open() {
    this.dialog.showModal();
    document.body.style.overflow = 'hidden';
  }

  unlockScrolling() {
    document.body.style.overflow = '';
  }

  render() {
    return (
      <dialog
        ref={(el) => (this.dialog = el)}
        onClick={() => this.shouldCloseOnClickingBackdrop && this.dialog.close()}
        onClose={() => this.unlockScrolling()}
        class="z-10 p-0 border-none w-11/12 h-5/6 backdrop:bg-black/50 overflow-visible">
        <form method="dialog" class="text-right">
          <button class="w-8 h-8 z-20 -ml-4 -mt-4 absolute rounded-full text-clrs-kbb-borderblue text-center align-middle cursor-pointer border-0">
            <svg-icon icon="x" />
          </button>
        </form>
        <iframe class="border-none w-full h-full" src={this.url}></iframe>
      </dialog>
    );
  }
}
